var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V112H496V16Z",
    fill: "#2980B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 112H16V208H496V112Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 208H16V304H496V208Z",
    fill: "#2980B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M496 304H16V400H496V304Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M496 400H16V496H496V400Z",
    fill: "#2980B9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L216 256.002L16 496V16Z",
    fill: "#E32D3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.548 312.054L100.93 283.416L63.0424 312.911L79.2722 270.186L39.5132 243.267L85.1625 245.5L98.4772 199.369L110.46 243.474L158.448 241.881L120.205 266.907L136.548 312.054Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCu);
export default __webpack_public_path__ + "static/media/CU.fb79bee6e50506b32cd3dbdb92b52ad0.svg";
export { ForwardRef as ReactComponent };